<template>
    <div>
        <div v-if="order.shipping_details" class="d-flex flex-column gap-5">
            <div class="d-flex flex-row gap-10">
                <div>
                    <div class="font-weight-bold mb-1">{{ __('orders.shipping.provider') }}</div>
                    <div v-for="shippingDetails in order.shipping_details"
                         :class="{'text-muted': !shippingDetails.transport_service}">
                        {{ shippingDetails.transport_service || __('general.unspecified') }}
                    </div>
                </div>
                <div>
                    <div class="font-weight-bold mb-1">{{ __('orders.shipping.tracking_code') }}</div>
                    <div v-for="shippingDetails in order.shipping_details"
                         :class="{'text-muted': !shippingDetails.tracking_code}">
                        {{ shippingDetails.tracking_code || __('general.unspecified') }}
                    </div>
                </div>
                <div>
                    <div class="font-weight-bold mb-1">{{ __('orders.shipping.invoiced_cost') }}</div>
                    <div v-for="shippingDetails in order.shipping_details">
                        <Price :value="shippingDetails.delivery_cost"/>
                    </div>
                </div>
            </div>
            <div>
                <div class="font-weight-bold mb-1">
                    {{ __('orders.documents.' + OrderDocumentType.SHIPPING_LABEL) }}
                </div>
                <div v-for="shippingDetails in order.shipping_details.filter(shipping => shipping.has_document)">
                    <embed type="application/pdf"
                           :src="`data:application/pdf;base64,${shippingDetails.meta.document.content}`"
                           width="100%"
                           height="600px"
                           :title="shippingDetails.tracking_code"
                    />
                </div>
            </div>
        </div>
        <div v-if="!order.shipping_details || order.shipping_details.length === 0">
            <div v-if="order.state === OrderState.Send">
                <div class="font-weight-bold text-xl">
                    {{ __('actions.provide_shipping_details') }}
                </div>
                <div class="form-group">
                    <label class="font-weight-bold">{{ __('orders.shipping.provider') }}</label>
                    <input type="text"
                           class="form-control form-control-solid"
                           placeholder="DHL, UPS, FedEx, ..."
                           v-model="shippingDetails.shippingProvider">
                </div>
                <div class="form-group">
                    <label class="font-weight-bold">{{ __('orders.shipping.tracking_code') }}</label>
                    <input type="text"
                           class="form-control form-control-solid"
                           placeholder="000000000000000"
                           v-model="shippingDetails.trackingCode">
                </div>
                <div class="mt-3">
                    <button class="btn btn-outline-success" @click="saveShippingDetails">
                        <i class="fas fa-save mr-1"/>
                        {{ __('actions.submit') }}
                    </button>
                </div>
            </div>
            <div v-else>
                {{ __('orders.shipping.details_not_provided') }}
            </div>
        </div>
    </div>
</template>

<script>
import {OrderState} from '@composables/orderStates';
import Price from "@components/Price.vue";
import {OrderDocumentType} from "@generated/orderDocumentType";

export default {
    components: {Price},

    props: {
        store: Object,
        order: Object,
    },

    data() {
        return {
            shippingDetails: {
                shippingProvider: null,
                trackingCode: null,
            },
        };
    },

    methods: {
        saveShippingDetails() {
            this.$inertia.visit(this.$route('order.shipment', [this.store.id, this.order.url_key]), {
                data: {
                    shipping: {
                        provider: this.shippingDetails.shippingProvider,
                        tracking_code: this.shippingDetails.trackingCode,
                    },
                },
                only: ['order'],
                method: 'PATCH',
            });
        }
    },

    computed: {
        OrderDocumentType() {
            return OrderDocumentType
        },

        OrderState() {
            return OrderState
        },

        currency() {
            if (this.order.items.length === 0) {
                return -1;
            }

            return this.order.items[0].currency;
        },
    },
};
</script>
